import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/hooks/useAuth';

export function AuthCallbackPage() {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    async function verify() {
      await checkAuth();
      if (!cancelled) {
        // After checkAuth completes, useAuth state is updated.
        // We navigate to / and let ProtectedRoute handle the rest.
        navigate('/', { replace: true });
      }
    }

    void verify();
    return () => { cancelled = true; };
  }, [checkAuth, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-0">
      <div className="text-center">
        <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
        <p className="text-sm text-neutral-400">Authentifizierung wird überprüft…</p>
      </div>
    </div>
  );
}
